export enum TaxType {
  SYSTEM = "system",
  SPECIAL = "special",
  CHAIN = "chain",
}

export namespace TaxType {
  export const translateType = (type: TaxType): string => {
    switch (type) {
      case TaxType.SYSTEM:
        return "Sistema";
      case TaxType.SPECIAL:
        return "Especial";
      case TaxType.CHAIN:
        return "Rede";
      default:
        return "";
    }
  };

  export const taxTypeChoices: Array<{ id: string, name: string }> = Object.values(TaxType)
    .filter(x => typeof x === "string")
    .map((type) => ({
      id: type,
      name: TaxType.translateType(type as TaxType),
    } as { id: string, name: string }));
}